import { jwtDecode } from 'jwt-decode';
import { isTokenExpired, isTokenExpiringSoon } from '../services/authService';

interface DecodedToken { 
  'X-SC-Role': string;
  'X-SC-ID': string;
  'X-SC-Session-ID': string;
  'X-SC-Nonce': string;
  'X-SC-TokenType': string;
  exp: number;
  iss: string;
  aud: string;
}

export const getCurrentUserRole = (): string | null => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;
    
    const decoded: DecodedToken = jwtDecode(token);
    return decoded['X-SC-Role'] || null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const getCurrentUserId = (): string | null => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) return null;
    
    const decoded: DecodedToken = jwtDecode(token);
    return decoded['X-SC-ID'] || null;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const getCurrentUserInfo = (): { role: string | null; id: string | null } => {
  return {
    role: getCurrentUserRole(),
    id: getCurrentUserId()
  };
};

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('accessToken');
  if (!token) return false;
  
  try {
    return !isTokenExpired(token);
  } catch (error) {
    console.error('Error checking authentication status:', error);
    return false;
  }
};

export const shouldRefreshToken = (): boolean => {
  const token = localStorage.getItem('accessToken');
  if (!token) return false;
  
  try {
    return isTokenExpiringSoon(token, 5);
  } catch (error) {
    console.error('Error checking token refresh need:', error);
    return false;
  }
};

export const clearAuthData = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('username');
  localStorage.removeItem('userId');
  localStorage.removeItem('accessTokenExpiredAt');
  localStorage.removeItem('refreshTokenExpiredAt');
};

export const logout = (): void => {
  clearAuthData();
  window.location.href = '/login';
};
